import React from 'react';

import {
  useLoginRecordsState,
  useLoginRecordsActions
} from './LoginRecordsContext';

import {
  getLoginRecords,
} from './restApi';

import PageController from '../../Shared/UI/PageController/components/PageController';

const LoginRecordsPageController = () => {
  const loginRecordsState = useLoginRecordsState();
  const { onResponse, onError } = useLoginRecordsActions();

  return (
    <PageController
      pageNumber={loginRecordsState?.pageNumber}
      numberOfPages={loginRecordsState?.numberOfPages}
      goToFirstPage={() => {
        getLoginRecords({
          onResponse,
          onError,
          pageNumber: 1,
        });
      }}
      goToPreviousPage={() => {
        getLoginRecords({
          onResponse,
          onError,
          pageNumber: (loginRecordsState?.pageNumber - 1),
        });
      }}
      goToNextPage={() => {
        getLoginRecords({
          onResponse,
          onError,
          pageNumber: (loginRecordsState?.pageNumber + 1),
        });
      }}
      goToLastPage={() => {
        getLoginRecords({
          onResponse,
          onError,
          pageNumber: loginRecordsState?.numberOfPages,
        });
      }}
    />
  );
};

export default LoginRecordsPageController;
